<template>
  <Modal>
    <Modal.Title>{{ title }}</Modal.Title>
    <Modal.Body>
      <p class="text-[14px] leading-[22px] text-gray-800">{{ body }}</p>
    </Modal.Body>
    <Modal.Footer layout="vertical">
      <Button
        variant="primary"
        :size="isMobile ? 'lg' : 'md'"
        @click="handleOkay"
      >
        Okay
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Button } from '@dacr/library'
import { signout } from '@dacr/auth'
import { useRouter } from 'vue-router'

import { useDevice } from '@/shared/composables/useDevice'
import { NativeActionsEnum, useWebviewStore } from '@/shared/stores/webview'
import { closeAllModals } from '@/shared/dialogs/modals'
import { closeAllSheets } from '@/shared/dialogs/sheets'

const props = defineProps<{
  title: string
  body: string
  clearStorage?: boolean
}>()

const router = useRouter()
const webviewStore = useWebviewStore()
const { isMobile } = useDevice()

const handleOkay = () => {
  closeAllModals()
  closeAllSheets()

  signout()

  if (props.clearStorage) window.localStorage.clear()

  if (webviewStore.isActive) {
    webviewStore.postMessage({ type: NativeActionsEnum.SignOut })
  } else {
    router.push('/signout')
  }
}
</script>
